import styled from "styled-components";
import { UnstyledButtonLink } from "../ButtonLink/ButtonLink";
import { ReactComponent as Paperclip } from "../../assets/icons/paperclip.svg";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { Body } from "../Text/Text";

const StyledBody = styled(Body)`
    margin-top: 20px;
    opacity: 0.8;
`;

const Table = styled.table`
    width: 100%;
    font-size: var(--fs-body-small);
    text-align: left;
    border-collapse: collapse;
    table-layout: ${props => props.$isMobile ? 'auto' : 'fixed'};
    min-width: 500px;
`

const TableHead = styled.thead`
    font-weight: var(--fw-semi-bold);
    
    th {
        padding: 20px 12px;
        border-bottom: 1px solid var(--color-light-600);
    }
    
    tr th:first-child {
        padding-left: 0;
    }
    tr th:last-child {
        padding-right: 0;
    }
`;

const TableBody = styled.tbody`
    td {
        padding: 20px 12px;
        border-bottom: 1px solid var(--color-light-600);
        align-items: center;
        
        svg {
            margin-top: 4px;
            margin-bottom: -4px;
            margin-right: 8px;
            
            @media screen and (max-width: 840px) {
                margin-right: 4px;
            }
        }
        
        button {
            text-decoration: underline;
            
            &:hover {
                color: var(--color-orange);
            }
        }
    }

    tr:last-child td {
        border-bottom: none;
    }
    
    tr td:first-child {
        text-decoration: none;
        padding-left: 0;
    }
    tr td:last-child {
        padding-right: 0;
    }
`;

const LinkButton = styled(UnstyledButtonLink)`
    color: var(--color-black);
    white-space: nowrap;
    
    &:hover {
        text-decoration: underline;
    }
`;

const TableCell = ({ id, type, children }) => {
    if (!id || !type) return <td>-</td>;

    return (
        <td>
            <LinkButton to={`/studenten/${id}/${type}`} target="_blank" rel="noopener noreferrer">
                <Paperclip/>
                {children}
            </LinkButton>
        </td>
    )
}

export const StudentTable = ({ students, ...props }) => {

    const {width} = useWindowDimensions();
    let isMobile = width <= 525;

    if (!students || students.items?.length === 0) return (
        <StyledBody $small>Geen studenten gevonden</StyledBody>
    );

    return (
        <Table $isMobile={isMobile} {...props}>
            {!isMobile && <colgroup>
                <col style={{ width: "43%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "19%" }} />
                <col style={{ width: "19%" }} />
            </colgroup>}

            <TableHead>
                <tr>
                    <th>Naam</th>
                    <th>CV</th>
                    <th>Cijferlijst</th>
                    <th>Motivatiebrief</th>
                </tr>
            </TableHead>
            <TableBody>
                {students?.items?.map(student => (
                    <tr key={student.id}>
                        <td>{student?.name}</td>
                        <TableCell id={student?.id} type={student?.cv ? "cv" : null}>CV</TableCell>
                        <TableCell id={student?.id} type={student?.gradeList ? "cijferlijst" : null}>Cijferlijst</TableCell>
                        <TableCell id={student?.id} type={student?.motivationLetter ? "motivatiebrief" : null}>Motivatiebrief</TableCell>
                    </tr>
                ))}
            </TableBody>
        </Table>
    )
}